import http from "./httpService";
import config from "./../config.json";

let apiEndpoint = process.env.REACT_APP_API_URL || config.apiUrl;
apiEndpoint += "payment-confirmations";

export const createPaymentFromConfirmationAsync = async (data) => {
  const url = `${apiEndpoint}/payments/${data.account_id}/${data.status}`;

  return await http.post(url, data);
};

export const saveConfirmationStatusAsync = async (data) => {
  const url = `${apiEndpoint}/statuses/${data.id}/${data.status}`;

  return await http.put(url);
};

export const getPaymentConfirmationAsync = async (params) => {
  const {
    sort_column,
    status,
    size,
    search_query: query,
    current_page: page,
  } = params;

  const { path: column, order } = sort_column;
  const url = `${apiEndpoint}?q=${query}&status=${status}&column=${column}&order=${order}&p=${page}&s=${size}`;

  const { data } = await http.get(url);
  return data;
};

export const getPaymentConfirmationStatuses = () => {
  return [
    { value: 1, label: "Awaiting Confirmation" },
    { value: 2, label: "Approved" },
    { value: 3, label: "Declined" },
  ];
};

export const paymentConfirmationServices = {
  createPaymentFromConfirmationAsync,
  saveConfirmationStatusAsync,
  getPaymentConfirmationAsync,
  getPaymentConfirmationStatuses,
};

export default paymentConfirmationServices;
